import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Input, Button, Card, CardHeader, CardBody, Label, FormFeedback, InputGroup, InputGroupText, Tooltip } from 'reactstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import { FiUpload } from 'react-icons/fi';
import cogoToast from 'cogo-toast';
import { useDispatch, useSelector } from 'react-redux';
import { POST_IMAGE, POST_IMAGE_EMPTY } from '../../../../../../../../store/actions';
import moment from 'moment';
import { AiFillInfoCircle } from 'react-icons/ai';

const Form1 = ({ formData, setFormData, onNext, errors, setErrors }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const statusOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'live', label: 'Live' },
  ];

  const [ttop, setttop] = useState(false);
  console.log('checkdata', formData);
  const timeUnits = [
    { value: 'seconds', label: 'Second' },
    { value: 'minutes', label: 'Minute' },
  ];

  const { createUploadTicket } = useSelector((state: any) => ({
    createUploadTicket: state?.PostImage?.data,
    createUploadTicketLoading: state?.PostImage?.loading,
  }));

  useEffect(() => {
    if (createUploadTicket !== null) {
      setFormData({ ...formData, banner: createUploadTicket?.data });
      dispatch({
        type: POST_IMAGE_EMPTY,
      });
    }
  }, [createUploadTicket]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => ({
      ...prev,
      [name]: newValue,
    }));

    // Clear the error for this field
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleFlatpickrChange = (name, date) => {
    setFormData(prev => ({
      ...prev,
      [name]: moment(new Date(date[0])).format('Y-MM-DD'),
    }));

    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleFileUpload = (files, type) => {
    const uploadedFile = files[0];
    if (!uploadedFile) return;

    const allowedExtensions = {
      image: ['jpg', 'jpeg', 'png', 'svg', 'webp'],
      video: ['mp4', 'avi', 'mov', 'mkv'],
    };

    const maxFileSize = {
      image: 10 * 1024 * 1024, // 10MB for images
      video: 50 * 1024 * 1024, // 50MB for videos
    };

    // Check if the provided type is valid
    if (!allowedExtensions[type]) {
      cogoToast.error(`Invalid file type: ${type}`);
      return;
    }

    const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();

    // Validate the file extension based on the type
    if (!allowedExtensions[type].includes(fileExtension)) {
      cogoToast.error(`Invalid file extension for ${type}. Allowed: ${allowedExtensions[type].join(', ')}`);
      return;
    }

    // Validate the file size based on the type
    if (uploadedFile.size > maxFileSize[type]) {
      cogoToast.error(`File size exceeds the limit for ${type}. Max size: ${maxFileSize[type] / (1024 * 1024)}MB`);
      return;
    }
    const formData = new FormData();
    const newFile = new File([uploadedFile], uploadedFile.name, { type: uploadedFile.type });
    formData.append('file', newFile);
    dispatch({
      type: POST_IMAGE,
      payload: {
        data: formData,
        urlParam: {
          fileType: 4,
        },
      },
    });
    setErrors(prev => ({ ...prev, banner: '' }));
  };

  const triggerUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Card>
      <CardHeader className="mb-4 fw-medium fs-16">Spin the Wheel Configuration</CardHeader>
      <CardBody>
        <Row>
          <Col md={4}>
            <Label>Game Name</Label>
            <Input name="game_name" value={formData.game_name} onChange={handleChange} invalid={!!errors.game_name} />
            {errors.game_name && <FormFeedback>{errors.game_name}</FormFeedback>}
          </Col>

          <Col md={4}>
            <Tooltip
              placement="top"
              isOpen={ttop}
              target="TooltipTop"
              toggle={() => {
                setttop(!ttop);
              }}
            >
              Upload JPG, PNG. Resolution 500x500 max file size 10 MB
            </Tooltip>
            <Label>
              Upload Spin Banner{'  '}
              <span id="TooltipTop" className="cursor-pointer">
                <AiFillInfoCircle />
              </span>
            </Label>

            {/* Entire input clickable */}
            <div onClick={triggerUpload} style={{ cursor: 'pointer' }}>
              <InputGroup
                id="banner-upload"
                style={{
                  borderRadius: '5px',
                  overflow: 'hidden',
                  border: `1px solid ${errors?.banner ? '#dc3545' : '#d1d9e6'}`,
                  height: '40px',
                }}
                // id="banner-upload"
              >
                <Input
                  placeholder={formData?.banner ? formData?.banner : 'Upload Banner'}
                  disabled
                  style={{
                    backgroundColor: '#f9fafb',
                    color: '#6b7280',
                    border: 'none',
                    pointerEvents: 'none', // prevent native focus behavior
                  }}
                  invalid={!!errors.banner}
                  // id="banner-upload"
                />
                <InputGroupText
                  style={{
                    backgroundColor: '#f9f9f9',
                    borderLeft: 'none',
                    pointerEvents: 'none', // icon should not steal the click
                    height: '40px',
                  }}
                >
                  <FiUpload size={18} />
                </InputGroupText>
              </InputGroup>
            </div>

            {/* Hidden file input */}
            <input type="file" accept="image/*" ref={fileInputRef} onChange={e => handleFileUpload(e.target.files, 'image')} hidden />

            {!!errors.banner && <FormFeedback style={{ display: 'block' }}>{errors.banner}</FormFeedback>}
          </Col>

          <Col md={4}>
            <Label>Status</Label>
            <Select
              options={statusOptions}
              value={statusOptions.find(opt => opt.value === formData.status)}
              onChange={option => {
                setFormData(prev => ({ ...prev, status: option.value }));
                if (errors.status) {
                  setErrors(prevErrors => ({ ...prevErrors, status: undefined }));
                }
              }}
            />
            {errors.status && <div className="text-danger mt-1">{errors.status}</div>}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <Label>Min Points to Play Per User</Label>
            <Input
              type="number"
              name="min_coins_required"
              value={formData.min_coins_required}
              onChange={handleChange}
              onKeyDown={e => {
                if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
              }}
              invalid={!!errors.min_coins_required}
              onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                e.currentTarget.blur();
              }}
            />
            {errors.min_coins_required && <FormFeedback>{errors.min_coins_required}</FormFeedback>}
          </Col>

          <Col md={4}>
            <Label>Start Date</Label>
            <Flatpickr
              className={`form-control`}
              value={formData.start_date}
              options={{ dateFormat: 'Y-m-d' }}
              onChange={date => handleFlatpickrChange('start_date', date)}
            />
            {errors.start_date && <div className="invalid-feedback d-block">{errors.start_date}</div>}
          </Col>

          <Col md={4}>
            <Label>End Date</Label>
            <Flatpickr
              className={`form-control`}
              value={formData.end_date}
              options={{ dateFormat: 'Y-m-d' }}
              onChange={date => handleFlatpickrChange('end_date', date)}
            />
            {errors.end_date && <div className="invalid-feedback d-block">{errors.end_date}</div>}
          </Col>

          <Col md={4} className="mt-3">
            <Label>Overall Spin Time</Label>
            <Row>
              <Col>
                <Input
                  type="number"
                  name="play_duration"
                  value={formData.play_duration}
                  onChange={handleChange}
                  invalid={!!errors.play_duration}
                  onKeyDown={e => {
                    if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                  }}
                  onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                    e.currentTarget.blur();
                  }}
                />
                {errors.play_duration && <FormFeedback>{errors.play_duration}</FormFeedback>}
              </Col>
              <Col>
                <Select
                  options={timeUnits}
                  value={timeUnits.find(opt => opt.value === formData.play_duration_unit)}
                  onChange={option => {
                    setFormData(prev => ({ ...prev, play_duration_unit: option.value }));
                    if (errors.play_duration_unit) {
                      setErrors(prevErrors => ({ ...prevErrors, play_duration_unit: undefined }));
                    }
                  }}
                />
                {errors.play_duration_unit && <div className="text-danger mt-1">{errors.play_duration_unit}</div>}
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={2}>
            <Label>Is Featured</Label>
            <div className="form-check form-switch">
              <Input
                type="checkbox"
                name="is_featured"
                className="form-check-input"
                checked={formData.is_featured}
                onChange={e => setFormData({ ...formData, is_featured: !formData?.is_featured })}
                style={{ width: '50px', height: '23px' }}
              />
            </div>
          </Col>

          <Col md={2}>
            <Label>Multiple Spin Allowed</Label>
            <div className="form-check form-switch">
              <Input
                type="checkbox"
                name="multipleSpinAllowed"
                className="form-check-input"
                checked={formData.multipleSpinAllowed}
                onChange={handleChange}
                style={{ width: '50px', height: '23px' }}
              />
            </div>
          </Col>

          {formData.multipleSpinAllowed && (
            <>
              <Col md={4}>
                <Label>Difference Between 2 Spin Time</Label>
                <Row>
                  <Col>
                    <Input
                      type="number"
                      name="tat"
                      value={formData.tat}
                      onChange={handleChange}
                      invalid={!!errors.tat}
                      onKeyDown={e => {
                        if ((e.key === '-' || e.key === ';', e.key === '.')) e.preventDefault();
                      }}
                      onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                        e.currentTarget.blur();
                      }}
                    />
                    {errors.tat && <FormFeedback>{errors.tat}</FormFeedback>}
                  </Col>
                  <Col>
                    <Select
                      options={timeUnits}
                      value={timeUnits.find(opt => opt.value === formData.tat_unit)}
                      onChange={option => {
                        setFormData(prev => ({ ...prev, tat_unit: option.value }));
                        if (errors.tat_unit) {
                          setErrors(prevErrors => ({ ...prevErrors, tat_unit: undefined }));
                        }
                      }}
                    />
                    {errors.tat_unit && <div className="text-danger mt-1">{errors.tat_unit}</div>}
                  </Col>
                </Row>
              </Col>

              <Col md={4}>
                <Label>User Attempts Per Game</Label>
                <Input
                  type="number"
                  name="total_attempts"
                  value={formData.total_attempts}
                  onChange={handleChange}
                  invalid={!!errors.total_attempts}
                  onKeyDown={e => {
                    if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                  }}
                  onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                    e.currentTarget.blur();
                  }}
                />
                {errors.total_attempts && <FormFeedback>{errors.total_attempts}</FormFeedback>}
              </Col>
            </>
          )}
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <Button color="success" style={{ fontSize: '17px', padding: '6px 57px', borderRadius: '8px' }} onClick={onNext}>
            Next
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default Form1;
